import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  TableData,
  Input,
  SecondaryButton
} from "extranet-component-library";
import { showSnackbar } from '../utils/parsers';
import alert from "../assets/img/ALERTA_CTM.svg";
import alert_alt from "../assets/img/ALERTA_CTM_alt.svg";
import { useStores } from "../hooks/useStores";
import AllStops from '../components/AllStops';
import ConfirmModal from '../components/ConfirmModal';
const { REACT_APP_STOPS_MAP } = process.env;

interface FavProps {
  favStops: Array<any>;
  allStops: Array<any>;
  loading: boolean;
}

const FavStops = ({ ...props }: FavProps) => {
  const { t } = useTranslation();
  const { myTibStore } = useStores();
  const [show, setShow] = useState({
    addStop: false,
    searchStop: "",
  });
  const [showConfirm, setShowConfirm] = useState({ show: false, id: -1 });

  const handleRemove = ({ ...data }) => {
    myTibStore.removeStop(data.stopId);
  };

  const handleAdd = ({ ...data }) => {
    setShowConfirm({ show: true, id: data.id });
  };

  const onAccept = () => {
    setShowConfirm({ ...showConfirm, show: false });
    showSnackbar();
    myTibStore.addStop(showConfirm.id);
    setShow({ ...show, addStop: false });
  }

  const onReject = () => {
    setShowConfirm({ show: false, id: -1 });
  }

  const handleAlert = ({ ...data }) => {
    const { row, checked } = data;
    myTibStore.updateStop(row.stopId, checked.toString());
  };

  const handleShow = (data: any) => {
    myTibStore.getAllStops(data.searchStop);
    setShow({ ...data });
  };

  return (
    <div className="favs-table">
      <>
        <Modal
          visible={show.addStop}
          content={
            <div>
              {showConfirm.show ? <ConfirmModal onReject={onReject} onAccept={onAccept} /> : ''}
              <div className="flex-container justify-end">
                <div className="title">{t("fav_stops")}</div>
                <SecondaryButton
                  tooltip={t("go_map")}
                  text={t("stops_map")}
                  onClick={() => window.open(REACT_APP_STOPS_MAP, "_blank")}
                />
              </div>
              <>
                <div className="subtitle">
                  <Input
                    disabled={false}
                    placeholder={t("search_fav_stop")}
                    label=""
                    value={show.searchStop}
                    onChange={(e) =>
                      handleShow({ ...show, searchStop: e.target.value })
                    }
                  />
                </div>
                <AllStops allStops={props.allStops} handleAdd={handleAdd} />
              </>
            </div>
          }
          onHide={() => handleShow({ ...show, addStop: false, searchStop: "" })}
        />
        <div className="flex-container justify-end">
          <div className="title">{t("fav_stops")}</div>
          <SecondaryButton
            icon="plus"
            text={t("add")}
            onClick={() => handleShow({ ...show, addStop: true })}
          />
        </div>
        {props.favStops.length ? (
          <TableData
            rows={5}
            items={props.favStops}
            headers={[
              { id: "code", label: t("code") },
              { id: "name", label: t("name") },
              { id: "notifications", label: t("headers.alerts") },
              { id: "action", label: "" },
            ]}
            icon="times"
            alertSvg={alert}
            alertSvg_alt={alert_alt}
            loading={props.loading}
            onNotificationClick={(data: any) => handleAlert(data)}
            onActionClick={(data: any) => handleRemove(data)}
          />
        ) : (
          <div data-testid="no-stops" className="no_items">
            {t("no_items")}
          </div>
        )}
      </>
    </div>
  );
};

export default FavStops;
